// The app is not a PWA. Remove any service worker an old build installed so
// it can't serve stale files.
export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
  }
}
